import DataGrid, {
    Column,
    Pager,
    Paging,
    Scrolling,
    SearchPanel,
    Summary,
    TotalItem
} from 'devextreme-react/cjs/data-grid';
import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { getPoProductListById } from '../services/po.order.service';
import CustomStore from 'devextreme/data/custom_store';

interface POdetailsProp {
    selectedId: number | undefined;
    isViewModalOpen: boolean;
    onClose: () => void;
}

const POdetails: React.FC<POdetailsProp> = ({
    selectedId,
    isViewModalOpen,
    onClose
}) => {

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: "id",
            load: async (loadOptions) => {
                try {
                    const { searchValue, skip, take } = loadOptions;
                    const parameterList = new URLSearchParams();

                    if (typeof skip === 'number')
                        parameterList.append('skip', skip.toString());

                    if (typeof take === 'number')
                        parameterList.append('take', take.toString());

                    const search = JSON.parse(JSON.stringify(loadOptions));

                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }

                    if (searchValue) {
                        parameterList.append("search", searchValue);
                    }

                    if (selectedId) {
                        parameterList.append("poOrderId", String(selectedId))
                    }

                    const response = await getPoProductListById(parameterList);

                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            },
        });
    };

    return (
        <>
            <Modal
                show={isViewModalOpen}
                onHide={onClose}
                backdrop="static"
                size="xl"
                dialogClassName="modal-dialog-centered"
            >
                <Modal.Header closeButton>
                    <Modal.Title>PO Order Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <DataGrid
                        dataSource={dataSource()}
                        remoteOperations={{ groupPaging: true }}
                        showRowLines={true}
                        keyExpr="id"
                        showBorders={true}
                        columnAutoWidth={true}
                        onContentReady={(e) => {
                            const hasData = e.component.totalCount() > 0;
                            e.component.option("pager.visible", hasData);
                            e.component.option("paging.visible", hasData);
                        }}
                        className='text-center'
                    >

                        <Scrolling
                            mode="standard"
                            useNative={true}
                            scrollByContent={true}
                            scrollByThumb={true}
                        />

                        <Pager
                            showPageSizeSelector
                            allowedPageSizes={[10, 25, 50, 100]}
                            showNavigationButtons
                            displayMode="full"
                            showInfo
                        />

                        <SearchPanel
                            visible={true}
                            width={240}
                            placeholder="Search..."
                        />

                        <Summary>
                            <TotalItem />
                        </Summary>

                        <Paging defaultPageSize={10} />

                        <Column dataField="id" visible={false} />

                        <Column dataField="styleNo" caption="Style No" />
                        <Column dataField="category" caption="Category" />
                        <Column dataField="materialType" caption="Material Type" />
                        <Column dataField="color" caption="Color" />
                        <Column dataField="karat" caption="Karat" />
                        <Column dataField="qty" caption="Quantity" />

                        <Column dataField="standardGoldWeight" caption="Std Gold Wt" format={{ type: "fixedPoint", precision: 3 }} />
                        <Column dataField="standardDiamondWeight" caption="Std Diamond Wt" format={{ type: "fixedPoint", precision: 3 }} />

                        <Column dataField="expectedGoldRate" caption="Expected Gold Rate" format={{ type: "fixedPoint", precision: 2 }} />
                        {/* <Column dataField="expectedDiamondRate" caption="Expected Diamond Rate" format={{ type: "fixedPoint", precision: 2 }} />
                        <Column dataField="expectedMakingRate" caption="Expected Making Rate" format={{ type: "fixedPoint", precision: 2 }} /> */}

                        <Column dataField="actualGoldWeight" caption="Actual Gold Wt" format={{ type: "fixedPoint", precision: 3 }} />
                        <Column dataField="actualDiamondWeight" caption="Actual Diamond Wt" format={{ type: "fixedPoint", precision: 3 }} />

                        <Column dataField="goldCost" caption="Gold Cost" format={{ type: "fixedPoint", precision: 2 }} />
                        <Column dataField="diamondCost" caption="Diamond Cost" format={{ type: "fixedPoint", precision: 2 }} />
                        <Column dataField="makingCharges" caption="Making Charges" format={{ type: "fixedPoint", precision: 2 }} />
                        <Column dataField="craftsmanshipCost" caption="Craftsmanship Cost" format={{ type: "fixedPoint", precision: 2 }} />
                        <Column dataField="otherCharges" caption="Other Charges" format={{ type: "fixedPoint", precision: 2 }} />
                        <Column dataField="totalCost" caption="Total Cost" format={{ type: "fixedPoint", precision: 2 }} />
                        <Column dataField="dpPrice" caption="DP Price" format={{ type: "fixedPoint", precision: 2 }} />

                        <Column dataField="bagNumber" caption="Bag No." />
                        <Column dataField="status" caption="Status" />
                        <Column dataField="isRecieved" caption="Received"
                            cellRender={({ data }) => <span>{data.isRecieved ? 'Yes' : 'No'}</span>}
                        />
                        <Column dataField="isSRP" caption="Is SRP"
                            cellRender={({ data }) => <span>{data.isSRP ? 'Yes' : 'No'}</span>}
                        />

                        <Column dataField="specialInstructions" caption="Special Instructions" width={250} />

                    </DataGrid>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default POdetails;